<template>
  <router-link
    :to="route"
    tag="div"
    class="logo-tile"
    :class="{ 'fixed':fixed }"
  >
    <img
      src="../assets/MB_Monogram_White_RGB.png"
      alt="Matt Barnes logo"
    >
  </router-link>
</template>

<script>
export default {
  props: {
    fixed: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    route () {
      return this.$route.path === '/about' ? '/' : '/about'
    }
  }
}
</script>

<style scoped lang="scss">
.logo-tile {
  display: flex;
  justify-content: center;
  align-items: center;
  top: 0;
  margin: 1rem;
  height: 65px;
  width: 65px;
  background: black;
  border-radius: 4px;
  box-shadow: 0px 1px 9px 4px rgba(128, 122, 122, 0.19);
  cursor: pointer;

  @media screen and (min-width: 640px) {
    margin: 2rem;
    height: 75px;
    width: 75px;
  }
}
.logo-tile.fixed {
  position: fixed;
}
</style>
